import React, { useState, useEffect, useCallback, useMemo } from 'react';
import animateValue from "../../js/app/utilities/animatedCount";

function InlineProgressBar(props) {
	const { current, total, displayPercent, vertical, animated, children, onHoverShow, showGreaterThanOneHundredAsRed } = props;
	const { isPositive, roundedPercent, percent, showAsRed } = useMemo(() => {
		const percent = current / total * 100;
		const isPositive = percent >= 0;
		const roundedPercent = Math.round(percent);
		const showAsRed = (showGreaterThanOneHundredAsRed && percent > 100) || (percent < 0);
		return {
			percent, roundedPercent, isPositive, showAsRed
		};
	}, [current, total]);

	const [animatedPercent, updateAnimatedPercent] = useState(animated ? 0 : roundedPercent);
	const [hovered, updateHovered] = useState(false);

	const mouseEnter = useCallback(() => {
		if(!onHoverShow) {
			return;
		}
		updateHovered(true);
	}, [onHoverShow]);

	const mouseLeave = useCallback(() => {
		if(!onHoverShow) {
			return;
		}
		updateHovered(false);
	}, [onHoverShow]);

	const animatedValueChanged = useCallback((value) => {
		updateAnimatedPercent(value);
	}, [current, total]);

	useEffect(() => {
		if(!animated) {
			updateAnimatedPercent(roundedPercent);
			return;
		}
		const animateValueControl = animateValue({
			end: roundedPercent,
			animatedValueChanged: animatedValueChanged,
			duration: animated ? 500 + (Math.abs(roundedPercent) * 3) : 0,
		});

		return () => {
			animateValueControl.stop();
		};
	}, [current, total]);


	const progressBarWidthDisplayed = useMemo(() => {
		return Math.abs(animatedPercent) > 100 ? 100 : Math.abs(animatedPercent);
	}, [animatedPercent]);

	return (
		<div
			onMouseEnter={mouseEnter}
			onMouseLeave={mouseLeave}
			className={`${vertical ? 'vertical-progress-bar-holder' : 'horizontal-progress-bar-holder'} progress-bar-holder`}>
			<div className="progress-bar">
				<div className="progress-track">
					<span className='percent_display'>
					{displayPercent && !hovered && <span>{Math.round(animatedPercent)}%</span>}
						{!hovered && children}
						{hovered && onHoverShow}
					</span>
					<div
						className={`progress-fill ${showAsRed ? 'negative' : 'positive'}`}
						style={{
							[vertical ? 'height' : 'width']: `${progressBarWidthDisplayed}%`
						}}
					/>
				</div>
			</div>
		</div>
	);
}

InlineProgressBar.defaultProps = {
	displayPercent: false,
	vertical: false,
	animated: true,
	showGreaterThanOneHundredAsRed: true,
};

export default React.memo(InlineProgressBar);